module.exports = __webpack_public_path__ + "static/media/0.beginning.b4033e28.mp4";